import type { SubCondition } from './HubOptionState.types';
import { ConditionQuantifier } from './HubOptionState.types';

export type TagCondition = {
  uuid: string;
  quantifier: ConditionQuantifier;
  subConditions: SubCondition[];
  tagTemplateId: number;
};

export type HubOptionTag = {
  id?: number;
  tagTemplateId: number;
  sortOrder: number;
};

export const HUB_MAX_TAG_CONDITIONS = 10;
export const HUB_MAX_DEFAULT_TAGS = 1;
